export const BuildVersion = {
    Version: 'main',
    Build: 'e70dcdcc',
    Branch: 'develop'
};